<div class="custom" style="height: 100%; width: 100%">
  <div class="maintenance">
    <div class="container">
      <div class="row">
        <div class="col text-center">
          <div class="h1-eq">Unhandled error ...</div>
          <div class="h3-eq">
            An unexpected situation has occured. We are going to fix it soon.
          </div>
          <button
            type="button"
            onclick="history.back()"
            class="btn text-uppercase"
          >
            Back
          </button>
          <div class="h3-eq">© Megalearning</div>
        </div>
      </div>
    </div>
  </div>
</div>
